import { DocumentId } from 'preflight-core';

import { preflightApiClient } from '../api/client';

export function uploadInfo({
  documentId,
  url,
  retries = 2, // Number of retry attempts
  delay = 1500, // Delay between retries in milliseconds
}: {
  documentId: DocumentId;
  url: string;
  retries?: number;
  delay?: number;
}): Promise<boolean> {
  const jsonObject = {
    origin: url,
  };

  const attemptUpload = (remainingRetries: number): Promise<boolean> => {
    return preflightApiClient
      .post(`/uploadinfo/${documentId}`, jsonObject)
      .then(() => {
        return true;
      })
      .catch((error) => {
        // Retry logic
        if (remainingRetries > 0) {
          console.warn(
            `Retrying upload... Attempts remaining: ${remainingRetries - 1}`,
          );
          return new Promise((resolve) => setTimeout(resolve, delay)).then(() =>
            attemptUpload(remainingRetries - 1),
          );
        }

        // Log error only after all retries are exhausted
        if (error.response) {
          console.error('Upload failed with server response:', {
            status: error.response.status,
            data: error.response.data,
          });
        } else if (error.request) {
          console.error('No response received from server:', error.request);
        } else {
          console.error('Error during upload:', error.message);
        }

        console.error('Full error details:', error);

        // If no retries are left, return false
        return false;
      });
  };

  return attemptUpload(retries);
}
